


































import { Prop, Vue, Component } from 'vue-property-decorator';
import { FontAwesomeIcon } from '@fortawesome/vue-fontawesome';
import APSLocation from '@/entities/APSLocation';


@Component({
    components: {
        FontAwesomeIcon,
    },
})
export default class ASPList extends Vue {
  @Prop() public total!: number;
  @Prop() public filteredLocations!: APSLocation[];
}
